import React from 'react'
import { render } from 'react-dom'

import { ExternalModalAdapter } from '../../Common/Components/Modal/ExternalModalAdapter'
import { CommonFormContextProvider } from '../../Common/Contexts/CommonFormContext'
import { ManageQueuesModal } from '../Modal/ManageQueuesModal'
import { $window } from '../../../NonReact/common/AkixiWindow'

/**
 * Adapter to create the Users By Extension modal.
 */
export default class ManageQueuesAdapter extends ExternalModalAdapter {
    constructor() {
        super()

        $window.disableHotKeys = true

        render(
            <CommonFormContextProvider>
                <ManageQueuesModal />
            </CommonFormContextProvider>,
            this.modalDiv
        )
    }

    public static newInstance(): ManageQueuesAdapter {
        return new ManageQueuesAdapter()
    }
}
